<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/manager' }"
        >管理后台</el-breadcrumb-item
      >
      <el-breadcrumb-item>投诉列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <!-- 搜索栏 -->
      <!-- <el-row :gutter="10">
        <el-col :span="6">
          <el-input placeholder="输入账号" v-model="queryInfo.name"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="getManagersList">搜索</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="showAddDialog">添加</el-button>
        </el-col>
      </el-row> -->

      <!-- 管理员列表 -->
      <el-table border stripe :data="complaints">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="投诉内容" prop="content"></el-table-column>
        <!-- <el-table-column label="" prop="mg_mobile"></el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "Complaint",
  data() {
    return {
      //   投诉列表
      complaints: [],
      // 查询参数对象
      queryInfo: {
        name: "",
        pagenum: 1,
        pagesize: 10,
      },
      // 总数据条数
      total: 0,
    };
  },
  created() {
    this.getcomplaintList();
  },
  methods: {
    // 根据分页获取对应的投诉列表
    async getcomplaintList() {
      const { data: res } = await this.$http.get("complaint", {
        params: this.queryInfo,
      });

      if (res.meta.status !== 200) {
        return this.$message.error("获取投诉列表失败！");
      }
      this.$message.success("获取投诉列表成功！");
    //   console.log(res.data);
      this.complaints = res.data.complaints;
      this.total = res.data.total;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.getcomplaintList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getcomplaintList();
    },
  },
};
</script>
<style scoped>
</style>